function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-465.000000, -153.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(466.000000, 154.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.8412299,-3.00935747e-14 C28.4391957,-3.00935747e-14 31.3559233,2.9167276 31.3559233,6.51469343 L31.3559233,20.8383461 C31.3559233,24.4363119 28.4391957,27.3530395 24.8412299,27.3530395 L22.6811837,27.3528114 L22.6815063,35.5489441 L17.5556677,27.3528114 L6.51469343,27.3530395 C2.9167276,27.3530395 0,24.4363119 0,20.8383461 L0,6.51469343 C0,2.9167276 2.9167276,-3.00935747e-14 6.51469343,-3.00935747e-14 L24.8412299,-3.00935747e-14 Z",
  id: "Combined-Shape",
  stroke: "#8B6BD9",
  strokeWidth: 1.68121121,
  fill: "#8B6BD9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "$",
  transform: "translate(9.123382, 1.368507)",
  fill: "#FFFFFF",
  fontFamily: "Roboto-Regular, Roboto",
  fontSize: 20.0967006,
  fontWeight: "normal"
}, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
  x: 0.288382763,
  y: 19.5138456
}, "$"))))));

var SvgTextpayLogoMobile = function SvgTextpayLogoMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "40px",
    viewBox: "0 0 34 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTextpayLogoMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/textpay-logo-mobile.b55a2927.svg";
export { ForwardRef as ReactComponent };